import { RAW_DATA, NOT_EQUAL_VALUE, HYPOTHESIS_MEAN } from '../Constants';


export const valueInferentialStatisticsForm = {
  procedureOneSample: HYPOTHESIS_MEAN,
  alternativeHypothesis: NOT_EQUAL_VALUE,
  hypothesisMean: '0',
  hypothesisProportion: '0.5',
  dfHypothesisProportion: '0',
  confidenceInterval: '95'
};

export const valueOneSampleT = {
  numericalRowDataSet: '',
  sampleMean: '0',
  standardDeviation: '1',
  sampleSize: '10'
};


export const valueTwoSampleT = {
  sampleMeanFirst: '0',
  standardDeviationFirst: '1',
  sampleSizeFirst: '10',
  firstVariable: '',
  sampleMeanSecond: '0',
  standardDeviationSecond: '1',
  sampleSizeSecond: '10',
  secondVariable: '',
  assumeEqualVariances: false
};

export const valueOneSampleProportion = {
  numberOfSuccess: '1',
  numberOfTrials: '2',
  levelsRowDataSet: '',
  categoricalRowDataSet: ''
};

export const valueTwoSampleProportion = {
  numberOfSuccessFirst: '1',
  numberOfSuccessSecond: '1',
  numberOfTrialsFirst: '2',
  numberOfTrialsSecond: '2',
  firstVariable: '',
  secondVariable: '',
  successGroupFirst: '',
  successGroupSecond: ''
};

export const valuePairedT = {
  sampleMeanDiff: '0',
  standardDeviationDiff: '1',
  sampleSize: '10',
  hypothesisMean: '0',
  datasetContains: RAW_DATA
};

export const valueAnova = {
  numbersOfGroups: '3',
  anovaConfidenceInterval: '95',
  activeIndexTabAnova: 0,
  datasetContains: RAW_DATA,
  groups: [{
    name: 'Group 1',
    sampleMeanGroup1: 0,
    stDeviationGroup1: 1,
    sampleSizeGroup1: 10
  },
  {
    name: 'Group 2',
    sampleMeanGroup2: 0,
    stDeviationGroup2: 1,
    sampleSizeGroup2: 10
  },
  {
    name: 'Group 3',
    sampleMeanGroup3: 0,
    stDeviationGroup3: 1,
    sampleSizeGroup3: 10
  }]
};
